import OrganizationCreationPage from '@/pages/admin/OrganizationCreationPage/OrganizationCreationPage.vue'

export default OrganizationCreationPage
